import {Button,Card,Col,DatePicker,Flex,Form,Input,message,Row,Select,Typography,Upload} from 'antd';
import React,{useState} from 'react'
import AxiosService from '../services/APIService';
import {PlusOutlined,UploadOutlined} from '@ant-design/icons';
import ContactInput from '../components/ContactInput';
import dayjs from 'dayjs';
import {useNavigate} from 'react-router-dom';
import pipLogo from '../assets/whiteLogo.png'
import {fileSizeValidation} from '../utils/commonFunc';
const {Paragraph,Title} = Typography;

function WlRegister() {
    const apiService = new AxiosService()
    const [form] = Form.useForm()
    const [fileList,setFileList] = useState([]);
    const [isLoading,setIsLoading] = useState(false);
    const [userPreference,setuserPreference] = useState("Mr.");
    const navigate = useNavigate()
    const handleChange = ({fileList: newFileList}) => setFileList(newFileList);
    const formSubmit = (val) => {
        if(val.docs.fileList.length === 0) {
            message.error("Please upload at least 1 Document.")
            return
        }
        const formData = new FormData()

        formData.append("fullName",val?.fullname)
        if(val?.phoneNo) formData.append("phone_no",val?.phoneNo)
        formData.append("whatsapp_no",val?.whatsappNo)
        formData.append("street",val?.street)
        formData.append("city",val?.city)
        formData.append("state",val?.state)
        formData.append("country",val?.country)
        formData.append("pincode",val?.pincode)
        formData.append("email",val?.username)
        formData.append("business_email",val?.email)
        formData.append("dob",val?.dob)
        formData.append("password",val?.password)
        formData.append("reference_by",val?.refName)
        formData.append("pref",userPreference)
        if(val?.account_created_date) formData.append("account_created_date",val?.account_created_date)
        formData.append("name",val.whiteLabel)
        if(val.business_email) formData.append("business_email",val.business_email)
        if(val.website_address) formData.append("website_address",val.website_address)
        if(val?.logo) formData.append("logo",val.logo.file)

        val.docs.fileList.forEach((fl,i) => {
            formData.append(`doc${i}`,fl.originFileObj)
        });
        setIsLoading(true)
        console.log(val);
        
        apiService.post('auth/create-white-label',formData)
            .then(() => {
                message.success(`User created successfully`);
                navigate('/login/white_label')
            })
            .catch((e) => message.error(e.message))
            .finally(() => setIsLoading(false))
    }
    const uploadButton = (
        <button
            style={{
                border: 0,
                background: 'none',
            }}
            type="button"
        >
            <PlusOutlined />
            <div
                style={{
                    marginTop: 8,
                }}
            >
                Upload
            </div>
        </button>
    );
    return (
        <div className="register-wrapper">
            <Flex style={{marginBottom: 20}}>
                <img src={pipLogo} style={{width: '300px'}} />
            </Flex>
            <Card style={{width: "800px"}} title="White Label Registration">
                <Form
                    form={form}
                    layout="vertical"
                    onFinish={formSubmit}
                    style={{marginBottom: 20}}
                >
                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item label="White label" name="whiteLabel" rules={[{required: true,message: 'Please Enter White label Name!'}]}>
                                <Input placeholder="Enter White label Name" />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label="Logo" name="logo">
                                <Upload
                                    beforeUpload={() => false}
                                    accept=".png"
                                    maxCount={1}
                                >
                                    <Button icon={<UploadOutlined />}>Click to Upload</Button>
                                </Upload>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label="Owner Name" name="fullname" rules={[{required: true,message: 'Please Enter Owner Name!'}]}>
                                <Input addonBefore={<Select style={{width: 70}} onChange={setuserPreference} defaultValue={userPreference} options={[
                                    {value: "Mr.",label: "Mr."},
                                    {value: "Ms.",label: "Ms."},
                                    {value: "Mrs.",label: "Mrs."},
                                ]} />} placeholder="Enter Owner Name" />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label="Email Address" name="email" rules={[{required: true,type: 'email',message: 'Please Enter valid email address!'}]}>
                                <Input placeholder="Enter Email" />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item label="Street" name={"street"} rules={[{required: true,message: 'Please Enter Street!'}]}>
                                <Input placeholder="Street" />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Row gutter={16}>
                                <Col span={12}>
                                    <Form.Item label="City" name={"city"} rules={[{required: true,message: 'Please Enter City!'}]}>
                                        <Input placeholder="City" />
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item label="State" name={"state"} rules={[{required: true,message: 'Please Enter State!'}]}>
                                        <Input placeholder="State" />
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item label="Country" name={"country"} rules={[{required: true,message: 'Please Enter Country!'}]}>
                                        <Input placeholder="Country" />
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item label="Pincode" name={"pincode"} rules={[{required: true,message: 'Please Enter Pincode!'}]}>
                                        <Input placeholder="Pincode" />
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Col span={12}>
                            <ContactInput form={form} name='phoneNo' label='Phone No.' />
                        </Col>
                        <Col span={12}>
                            <ContactInput form={form} name='whatsappNo' label='Whatsapp No.' require={true} />
                        </Col>
                        <Col span={12}>
                            <Form.Item label="Business Email" name={"business_email"}>
                                <Input placeholder="Business Email" />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label="Website Address" name={"website_address"}>
                                <Input placeholder="Website Address" />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Col span={24}>
                            <Form.Item label="Document (Upload your National Identification Document in less then 2mb)" name="docs" rules={[{required: true,message: 'Documents requires'}]}>
                                <Upload
                                    listType="picture-card"
                                    fileList={fileList}
                                    onChange={handleChange}
                                    beforeUpload={fileSizeValidation}
                                    accept=".pdf, .jpg, .jpeg, .png"
                                >
                                    {fileList.length >= 8 ? null : uploadButton}
                                </Upload>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label="Account Created At" name="account_created_date" >
                                <DatePicker style={{width: '100%'}} defaultValue={dayjs()} format={{
                                    format: "DD-MM-YYYY",
                                    type: "mask"
                                }} />
                            </Form.Item>
                        </Col>
                        <Col span={12}></Col>
                        <Col span={12}>
                            <Form.Item label="Date of Birth" name="dob" rules={[{required: true,message: 'Please select date of birth!'}]}>
                                <DatePicker style={{width: '100%'}} format={{
                                    format: "DD-MM-YYYY",
                                    type: "mask"
                                }} />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label="User Name (Email id)" name="username" rules={[{required: true,type: 'email',message: 'Please Enter valid email address!'}]}>
                                <Input placeholder="Enter User Name" />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label="Password (user)" name="password" rules={[{required: true,message: 'Please Enter password!'}]}>
                                <Input.Password placeholder="Enter Password" />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label="User Confirm Password" name="confirmPassword" dependencies={['password']} rules={[
                                {
                                    required: true,
                                    message: 'Please confirm your password!',
                                },
                                ({getFieldValue}) => ({
                                    validator(_,value) {
                                        if(!value || getFieldValue('password') === value) {
                                            return Promise.resolve();
                                        }
                                        return Promise.reject(new Error('The new password that you entered do not match!'));
                                    },
                                }),
                            ]}>
                                <Input.Password placeholder="Confirm your Password" />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Button type="primary" htmlType="submit" loading={isLoading}>Submit</Button>
                </Form>
                <Title level={5}>DISCLAIMER</Title>
                <Paragraph
                    ellipsis={{
                        rows: 1,
                        expandable: true
                    }}
                >
                    Forex trading involves substantial risk, and it is important to recognize that even experienced traders may face significant losses. Studies suggest that 85%–95% of manual traders lose their entire capital. Engaging in Forex trading—whether manually or through an automated system—requires a thorough understanding of the risks involved.
                    Our automated trading solution is designed to optimize strategies and enhance trading efficiency, but it does not eliminate the inherent risks of the Forex market. Market volatility, execution delays, liquidity fluctuations, and technical failures can all lead to unexpected losses. While our system employs risk management strategies, there are no guarantees of consistent profits, and it is possible to lose your entire investment.
                    By using this trading system, you acknowledge and accept that: Trades are executed automatically based on pre-set parameters, which may become less effective due to unpredictable market changes. Risk management settings, including stop-loss limits, must be configured based on your financial goals and risk tolerance. The platform does not provide personalized financial advice, and all trading decisions are made at your own discretion and risk. Market disruptions, broker-related issues, or technical failures may impact the bot’s performance, and the platform is not liable for any resulting financial losses.
                    Forex trading may not be suitable for all investors. Only trade with funds you can afford to lose, and seek independent financial advice if you are uncertain about engaging in automated trading. Past performance does not guarantee future results. By using this service, you fully accept the risks and take full responsibility for your trading outcomes.
                </Paragraph>
            </Card>
        </div>
    )
}

export default WlRegister